import { type App, type DefineComponent } from 'vue'

import VCalendar from './src/components/Calendar/VCalendar.vue'
import VCalendarItem from './src/components/Calendar/VCalendarItem.vue'
import VCalendarItems from './src/components/Calendar/VCalendarItems.vue'
import VCalendarQuickOptions from './src/components/Calendar/VCalendarQuickOptions.vue'
import VCollapse from './src/components/Collapse/VCollapse.vue'
import VCollapseItem from './src/components/Collapse/VCollapseItem.vue'
import { $confirm } from './src/components/Confirm/index.ts'
import VConfirm from './src/components/Confirm/VConfirm.vue'
import VFormBuilder from './src/components/FormBuilder/VFormBuilder.vue'
import VFormBuilderQuestion from './src/components/FormBuilder/VFormBuilderQuestion.vue'
import VFormBuilderQuestionDropdown from './src/components/FormBuilder/VFormBuilderQuestionDropdown.vue'
import VFormBuilderQuestionRepeater from './src/components/FormBuilder/VFormBuilderQuestionRepeater.vue'
import VFormBuilderSection from './src/components/FormBuilder/VFormBuilderSection.vue'
import VFormBuilderSections from './src/components/FormBuilder/VFormBuilderSections.vue'
import VFormBuilderSelectQuestion from './src/components/FormBuilder/VFormBuilderSelectQuestion.vue'
import VIcon from './src/components/Icon/VIcon.vue'
import VNavbar from './src/components/Navbar/VNavbar.vue'
import VNavbarItem from './src/components/Navbar/VNavbarItem.vue'
import { $message, $notify } from './src/components/Notification/index.ts'
import VNotification from './src/components/Notification/VNotification.vue'
import VOption from './src/components/Select/VOption.vue'
import VOptionGroup from './src/components/Select/VOptionGroup.vue'
import VSelect from './src/components/Select/VSelect.vue'
import VStep from './src/components/Steps/VStep.vue'
import VSteps from './src/components/Steps/VSteps.vue'
import VTable from './src/components/Table/VTable.vue'
import VTableCell from './src/components/Table/VTableCell.vue'
import VTableColumn from './src/components/Table/VTableColumn.vue'
import VTableKeyValue from './src/components/Table/VTableKeyValue.vue'
import VTableKeyValueRow from './src/components/Table/VTableKeyValueRow.vue'
import VTextHighlight from './src/components/TextHighlight/VTextHighlight.vue'
import VFileList from './src/components/Upload/VFileList.vue'
import VUpload from './src/components/Upload/VUpload.vue'
import VUploadDragger from './src/components/Upload/VUploadDragger.vue'
import VAside from './src/components/VAside.vue'
import VAutocomplete from './src/components/VAutocomplete.vue'
import VAvatar from './src/components/VAvatar.vue'
import VBadge from './src/components/VBadge.vue'
import VButton from './src/components/VButton.vue'
import VCard from './src/components/VCard.vue'
import VCheckbox from './src/components/VCheckbox.vue'
import VCheckboxGroup from './src/components/VCheckboxGroup.vue'
import VCol from './src/components/VCol.vue'
import VColorPicker from './src/components/VColorPicker.vue'
import VContainer from './src/components/VContainer.vue'
import VDatePicker from './src/components/VDatePicker.vue'
import VDefer from './src/components/VDefer.vue'
import VDialog from './src/components/VDialog.vue'
import VErrors from './src/components/VErrors.vue'
import VFooter from './src/components/VFooter.vue'
import VForm from './src/components/VForm.vue'
import VFormBlueprint from './src/components/VFormBlueprint.vue'
import VFormBlueprintQuestion from './src/components/VFormBlueprintQuestion.vue'
import VFormBlueprintQuestionRepeater from './src/components/VFormBlueprintQuestionRepeater.vue'
import VFormBlueprintQuestionUpload from './src/components/VFormBlueprintQuestionUpload.vue'
import VGrid from './src/components/VGrid.vue'
import VHeader from './src/components/VHeader.vue'
import VIconHelp from './src/components/VIconHelp.vue'
import VInput from './src/components/VInput.vue'
import VInputUrl from './src/components/VInputUrl.vue'
import VLazy from './src/components/VLazy.vue'
import VLoadingBar from './src/components/VLoadingBar.vue'
import VLoadingDots from './src/components/VLoadingDots.vue'
import VMain from './src/components/VMain.vue'
import VMentionable from './src/components/VMentionable.vue'
import VMentionableOverlay from './src/components/VMentionableOverlay.vue'
import VPagination from './src/components/VPagination.vue'
import VPopover from './src/components/VPopover.vue'
import VPopper from './src/components/VPopper.vue'
import VProgress from './src/components/VProgress.vue'
import VProgressSteps from './src/components/VProgressSteps.vue'
import VRadio from './src/components/VRadio.vue'
import VRadioGroup from './src/components/VRadioGroup.vue'
import VResizeObserver from './src/components/VResizeObserver.vue'
import VSection from './src/components/VSection.vue'
import VSlider from './src/components/VSlider.vue'
import VSortCarets from './src/components/VSortCarets.vue'
import VSwitch from './src/components/VSwitch.vue'
import VTag from './src/components/VTag.vue'
import VTextarea from './src/components/VTextarea.vue'
import VTimeline from './src/components/VTimeline.vue'
import VTooltip from './src/components/VTooltip.vue'
import VTransitionCollapse from './src/components/VTransitionCollapse.vue'
import { bus } from './src/utils/bus.ts'
import { type Config, config } from './src/utils/config.ts'
import { dayjs } from './src/utils/day.ts'
import { type HTTPClient } from './src/utils/httpClient.ts'
import { setMessages } from './src/utils/i18n.ts'

export { type BaseQuestion, type Blueprint, type ExportedBlueprint, type Question, type QuestionType, useBlueprint } from './src/components/FormBuilder/useBlueprint.ts'
export { useErrors } from './src/composables/useErrors.ts'
export * from './src/composables/useForm.ts'
export { useResizeObserver } from './src/composables/useResizeObserver.ts'
export * from './src/types.ts'
export type { Dayjs } from './src/utils/day.ts'
export { DisabledHelp } from './src/utils/disabledHelp.ts'
export * from './src/utils/helpers.ts'
export * from './src/utils/httpClient.ts'
export * from './src/utils/injections.ts'
export * from './src/utils/sorting.ts'
export * from './src/utils/validation.ts'
export type { Config }
export type { Props as VSelectProps } from './src/components/Select/VSelect.vue'
export type { EditCell } from './src/components/Table/VTable.vue'
export type { TableColumn } from './src/components/Table/VTableColumn.vue'
export type { Mention, ModelValue as MentionableModelValue } from './src/components/VMentionable.vue'

export const components = {
  VAside,
  VAutocomplete,
  VAvatar,
  VBadge,
  VButton,
  VCalendar,
  VCalendarItem,
  VCalendarItems,
  VCalendarQuickOptions,
  VCard,
  VCheckbox,
  VCheckboxGroup,
  VCol,
  VCollapse,
  VCollapseItem,
  VColorPicker,
  VConfirm,
  VContainer,
  VDatePicker,
  VDefer,
  VDialog,
  VErrors,
  VFileList,
  VFooter,
  VForm,
  VFormBlueprint,
  VFormBlueprintQuestion,
  VFormBlueprintQuestionUpload,
  VFormBlueprintQuestionRepeater,
  VFormBuilder,
  VFormBuilderQuestion,
  VFormBuilderQuestionDropdown,
  VFormBuilderQuestionRepeater,
  VFormBuilderSection,
  VFormBuilderSections,
  VFormBuilderSelectQuestion,
  VHeader,
  VIcon,
  VIconHelp,
  VInput,
  VInputUrl,
  VLazy,
  VLoadingBar,
  VLoadingDots,
  VMain,
  VMentionable,
  VMentionableOverlay,
  VNavbar,
  VNavbarItem,
  VNotification,
  VOption,
  VOptionGroup,
  VPagination,
  VPopover,
  VPopper,
  VProgress,
  VProgressSteps,
  VRadio,
  VRadioGroup,
  VResizeObserver,
  VGrid,
  VSection,
  VSelect,
  VSlider,
  VSortCarets,
  VStep,
  VSteps,
  VSwitch,
  VTable,
  VTableCell,
  VTableColumn,
  VTableKeyValue,
  VTableKeyValueRow,
  VTag,
  VTextarea,
  VTextHighlight,
  VTimeline,
  VTooltip,
  VTransitionCollapse,
  VUpload,
  VUploadDragger,
} as const

interface PluginOptions {
  config?: Config
  components?: DefineComponent[]
  httpClient?: HTTPClient
  router?: { afterEach: (callback: () => void) => void }
}

const VartionUI = {
  install(app: App, options: PluginOptions = {}) {
    const componentsToInstall = options.components ?? components

    config.merge(options.config ?? {})
    config.app = app

    app.config.globalProperties.$notify = $notify
    app.config.globalProperties.$notify.config = $notify.config
    app.config.globalProperties.$message = $message
    app.config.globalProperties.$message.success = $message.success
    app.config.globalProperties.$message.warning = $message.warning
    app.config.globalProperties.$message.error = $message.error
    app.config.globalProperties.$confirm = $confirm
    app.config.globalProperties.$dayjs = dayjs

    options.router?.afterEach(() => {
      bus.emit('afterRouteChange')
    })

    if (options.httpClient) {
      config.VForm.httpClient = options.httpClient
    }

    for (const [name, component] of Object.entries(componentsToInstall)) {
      app.component(name, component)
    }
  },
}

export {
  $confirm,
  $message,
  $notify,
  config,
  dayjs,
  setMessages,
  VartionUI,
  VAside,
  VAutocomplete,
  VAvatar,
  VBadge,
  VButton,
  VCalendar,
  VCalendarItem,
  VCalendarItems,
  VCalendarQuickOptions,
  VCard,
  VCheckbox,
  VCheckboxGroup,
  VCol,
  VCollapse,
  VCollapseItem,
  VColorPicker,
  VConfirm,
  VContainer,
  VDatePicker,
  VDefer,
  VDialog,
  VErrors,
  VFileList,
  VFooter,
  VForm,
  VFormBlueprint,
  VFormBlueprintQuestion,
  VFormBlueprintQuestionUpload,
  VFormBuilder,
  VFormBuilderQuestion,
  VFormBuilderQuestionDropdown,
  VFormBuilderSection,
  VFormBuilderSections,
  VFormBuilderSelectQuestion,
  VGrid,
  VHeader,
  VIcon,
  VIconHelp,
  VInput,
  VInputUrl,
  VLazy,
  VLoadingBar,
  VLoadingDots,
  VMain,
  VMentionable,
  VMentionableOverlay,
  VNavbar,
  VNavbarItem,
  VNotification,
  VOption,
  VOptionGroup,
  VPagination,
  VPopover,
  VPopper,
  VProgress,
  VProgressSteps,
  VRadio,
  VRadioGroup,
  VResizeObserver,
  VSection,
  VSelect,
  VSlider,
  VSortCarets,
  VStep,
  VSteps,
  VSwitch,
  VTable,
  VTableCell,
  VTableColumn,
  VTableKeyValue,
  VTableKeyValueRow,
  VTag,
  VTextarea,
  VTextHighlight,
  VTimeline,
  VTooltip,
  VTransitionCollapse,
  VUpload,
  VUploadDragger,
}
